<template>
  <div>
    <el-button @click="toggleOverlay" type="text">
      <i class="far fa-question"></i> {{ $t('label.help') }}
    </el-button>
    <overlay-page v-if="show" @close="closeOverlay" :file="file" :anchor="anchor"  :meta="{ title }"></overlay-page>
  </div>
</template>

<script>
import OverlayPage from 'components/pages/professional/shared/help/page-help-overlay';

export default {
  name: 'nuttrema-overlay-help-button',
  components: {
    OverlayPage,
  },
  props: {
    file: {
      type: String,
      required: true,
      default: null,
    },
    anchor: {
      type: String,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toggleOverlay() {
      this.show = !this.show;
    },
    closeOverlay() {
      this.show = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/overlay/nuttrema-overlay-help-button.vue